module.exports = __webpack_public_path__ + "static/media/Jess McCluer Headshot.28c0f635.jpeg";